<template>
  <el-select v-model="tempData" placeholder="请选择" @change="change" :style="`width: ${width}`" :disabled="disabled" :clearable="clearable">
    <el-option v-for="item in list" :label="item.name" :value="item.id" :key="item.id"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "ShopTypeSelect",
    model: {
      event: 'change',
    },
    props: {
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: "100%",
      },
      value: [String, Number],
    },
    data() {
      return {
        tempData: this.value,
        list: []
      }
    },
    watch: {
      value(val) {
        this.tempData = val;
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        let nv = {
          page: 1,
          limit: 1000,
        };
        let res = await this.$Http.getShopType(nv);
        if (res?.data) {
          let obj = res.data.list || {};
          Object.keys(obj).forEach(key => this.list.push({id:+key, name:obj[key]}));
        }
      },
      change(val) {
        this.$emit('change', val)
      }
    }
  }
</script>

<style scoped>

</style>
